import type { ICustomDimensionPath } from '@similarweb/sw-track';

import type { Page } from '../../domain/page';

import getTrackingLocation from './getTrackingLocation';
import { allTrackers } from './tracking';
import type { TrackingConfigItem } from './trackingConfig';

const createTrackingPageViewService = () => {
  const trackPageView = ({
    isSwUser,
    config,
    url,
    page,
    params,
    eventName,
    section = 'si extension',
  }: {
    isSwUser: boolean;
    config: TrackingConfigItem | undefined;
    url: string;
    page: Page;
    params?: Record<string, string | number>;
    eventName?: string;
    section?: string;
  }) => {
    if (!config) {
      return;
    }
    const path: ICustomDimensionPath = {
      page_id: page,
      section,
      sub_section: config.subSection,
      sub_sub_section: config.subSubSection,
    };
    allTrackers.trackPageView({
      path,
      is_sw_user: isSwUser,
      lang: 'en',
      custom_data: { action: `see on ${getTrackingLocation(url)}`, event_name: eventName ?? url, ...params },
    });
  };

  return {
    trackPageView,
  };
};

const TrackingPageViewService = createTrackingPageViewService();

export default TrackingPageViewService;
